/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminBookingSession,
  AdminBookingSessionDetail,
  AdminV1OrganizationsBookingSessionsListParams,
  BookingSessionRescheduleInput
} from '.././model';

import adminV1OrganizationsBookingSessionsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBookingSessionsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBookingSessionsDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBookingSessionsRescheduleCreateMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * List unique booking sessions within a given date range.
(Note: Grouping currently uses first org instructor ID from context.
Needs review if multi-instructor sessions should list separately).
 * @summary List unique booking sessions within a given date range.
(Note: Grouping currently uses first org instructor ID from context.
Needs review if multi-instructor sessions should list separately).
 */
export const adminV1OrganizationsBookingSessionsList = (
    organizationId: number,
    params: AdminV1OrganizationsBookingSessionsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsBookingSessionsListMutator<AdminBookingSession[]>>,) => {
      return adminV1OrganizationsBookingSessionsListMutator<AdminBookingSession[]>(
      {url: `/api/admin/v1/organizations/${organizationId}/booking-sessions/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieve a single booking session slot by its composite ID.
 * @summary Retrieve a single booking session slot by its composite ID.
 */
export const adminV1OrganizationsBookingSessionsRetrieve = (
    organizationId: number,
    compositeId: string,
 options?: SecondParameter<typeof adminV1OrganizationsBookingSessionsRetrieveMutator<AdminBookingSessionDetail>>,) => {
      return adminV1OrganizationsBookingSessionsRetrieveMutator<AdminBookingSessionDetail>(
      {url: `/api/admin/v1/organizations/${organizationId}/booking-sessions/${compositeId}/`, method: 'GET'
    },
      options);
    }
  /**
 * Cancel all bookings in a session slot by its composite ID.
 * @summary Cancel all bookings in a session slot by its composite ID.
 */
export const adminV1OrganizationsBookingSessionsDestroy = (
    organizationId: number,
    compositeId: string,
 options?: SecondParameter<typeof adminV1OrganizationsBookingSessionsDestroyMutator<void>>,) => {
      return adminV1OrganizationsBookingSessionsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/booking-sessions/${compositeId}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Reschedule all bookings in a session slot to a new slot.
 * @summary Reschedule all bookings in a session slot to a new slot.
 */
export const adminV1OrganizationsBookingSessionsRescheduleCreate = (
    organizationId: number,
    compositeId: string,
    bookingSessionRescheduleInput: BookingSessionRescheduleInput,
 options?: SecondParameter<typeof adminV1OrganizationsBookingSessionsRescheduleCreateMutator<AdminBookingSessionDetail>>,) => {
      return adminV1OrganizationsBookingSessionsRescheduleCreateMutator<AdminBookingSessionDetail>(
      {url: `/api/admin/v1/organizations/${organizationId}/booking-sessions/${compositeId}/reschedule/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bookingSessionRescheduleInput
    },
      options);
    }
  export type AdminV1OrganizationsBookingSessionsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBookingSessionsList>>>
export type AdminV1OrganizationsBookingSessionsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBookingSessionsRetrieve>>>
export type AdminV1OrganizationsBookingSessionsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBookingSessionsDestroy>>>
export type AdminV1OrganizationsBookingSessionsRescheduleCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBookingSessionsRescheduleCreate>>>
